import he from 'he';

type SanitizationOptions = {
  decodeEntities?: boolean;
  removeBlocks?: boolean;
};

export const sanitizeText = (
  text: string,
  options: SanitizationOptions = { decodeEntities: true, removeBlocks: true },
): string => {
  let sanitizedText = text;

  if (options.decodeEntities) {
    sanitizedText = he.decode(sanitizedText);
  }

  if (options.removeBlocks) {
    sanitizedText = sanitizedText.replace(/\[block id=".*?"\]/g, '');
  }

  return sanitizedText;
};
